import script from "./UiDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDropdown.vue?vue&type=script&setup=true&lang=js"

import "./UiDropdown.vue?vue&type=style&index=0&id=efc1e042&lang=scss"
import "./UiDropdown.vue?vue&type=style&index=1&id=efc1e042&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efc1e042"]])

export default __exports__